module.exports = __webpack_public_path__ + "static/hero-download-sm-c88af548f16eaa2ed0bc929e0c24b8aa.jpg";